
export const allCourses = [
    {
        _id: 0,
        title: 'Graphic Design',
        img: '/resource/course/graph.jpg',
        price: '12000',
        duration: '6 month',
        discreption: 'Graphic design is a profession, academic discipline and applied art whose activity consists in projecting visual communications intended to transmit specific messages to social groups, with specific objectives. Graphic design is an interdisciplinary branch of design and of the fine arts. ',
        features: {
            future: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            certificate: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            courseDetails: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            skils: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.'
        },
        teacher: 'Lutfar Rahman',
        totalStudens: 240,
        rating: 5,
        totalAssignmet: 45,
        schedule: {
            day: ['Sunday', 'Monday', 'Friday'],
            time: '2 houre',
            week: '3 days',
            time: '1.00 PM to 3.00 AM'
        },
        totalClasses: 56,

    }, {
        _id: 1,
        title: 'Web Design',
        img: '/resource/course/webDesign.jpg',
        discreption: 'Web design encompasses many different skills and disciplines in the production and maintenance of websites. The different areas of web design include web graphic design; user interface design; authoring, including standardised code and proprietary software; user experience design; and search engine optimization.',
        features: {
            future: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            certificate: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            courseDetails: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            skils: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.'
        }, 
        price: '12000',
        duration: '6 month',
        teacher: 'Lutfar Rahman',
        totalStudens: 150,
        rating: 5,
        totalAssignmet: 30,
        schedule: {
            day: ['Satarday', 'Monday', 'Friday'],
            time: '3 houre',
            time: '12.00 PM to 2.00 AM'
        },
        totalClasses: 30,

    }, {
        _id: 2,
        title: 'Machine Shop Operations and Maintenance',
        img: '/resource/course/mechine operator.jpg',
        price: '15000',
        duration: '4 month',
        discreption: 'Machine Shop Operations and Maintenance describes traditional machine and hand-tool operations. Drill presses, lathes, mills, and other machine tools are described in detail, along with general instructions for their setup and operation. It also explains steel, alloys, heat treating, machinability, numerical controls, EDM, ECM, and electrolyte grinding.',
        features: {
            future: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            certificate: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            courseDetails: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            skils: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.'
        }, 
        teacher: 'Rakibul islam ',
        totalStudens: 100,
        rating: 3,
        totalAssignmet: 12,
        schedule: {
            day: ['Monday', 'Friday'],
            time: '2 houre',
            week: '2 days',
            time: '12.00 PM to 2.00 AM'
        },
        totalClasses: 20,

    }, {
        _id: 3,
        title: 'Laptop and Computer Repair and assembly ',
        img: '/resource/course/computer rep.jpg',
        price: '18000',
        duration: '3 month',
        discreption: 'Computer repair is the process of identifying, troubleshooting and resolving problems and issues in a faulty computer. Computer repair is a broad field encompassing many tools, techniques and procedures used to repair computer hardware, software or network/Internet problems.',
        features: {
            future: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            certificate: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            courseDetails: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            skils: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.'
        }, 
        teacher: 'Lutfar rahman',
        totalStudens: 400,
        rating: 2,
        totalAssignmet: 8,
        schedule: {
            day: ['Monday', 'Friday'],
            time: '2 houre',
            week: '2 days',
            time: '12.00 PM to 2.00 AM'
        },
        totalClasses: 16,

    }, {
        _id: 4,
        title: 'Motor Transformer and Generator Wiring',
        img: '/resource/course/motorTransformer.jpg',
        price: '15000',
        duration: '3 month',
        discreption: 'This highly informative Induction Motor & Transformer Application training course offers practical information about two of the most important types of electrical equipment. You will learn how to apply, maintain, and engineer the installation of power transformers and induction motors and associated equipment in an industrial & Transformer Application training course.',
        features: {
            future: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            certificate: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            courseDetails: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            skils: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.'
        }, 
        teacher: 'Lutfar rahman',
        totalStudens: 400,
        rating: 2,
        totalAssignmet: 8,
        schedule: {
            day: ['Monday', 'Friday'],
            time: '2 houre',
            week: '2 days',
            time: '12.00 PM to 2.00 AM'
        },
        totalClasses: 16,

    }, {
        _id: 5,
        title: 'CNC Operations and Maintenance',
        img: '/resource/course/cnc ope.jpg',
        price: '18000',
        duration: '3 month',
        discreption: 'A machine breakdown can cost a business thousands of dollars in wasted hours, overnight shipping of replacement parts, and missed deliveries, not to mention a damaged reputation. With so much high-tech equipment in one area, breakdowns are inevitable. ',
        features: {
            future: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            certificate: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            courseDetails: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            skils: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.'
        }, 
        teacher: 'Lutfar rahman',
        totalStudens: 400,
        rating: 2,
        totalAssignmet: 8,
        schedule: {
            day: ['Monday', 'Friday'],
            time: '2 houre',
            week: '2 days',
            time: '12.00 PM to 2.00 AM'
        },
        totalClasses: 16,

    }, {
        _id: 6,
        title: 'CNC Operations and Design',
        img: '/resource/course/cnc design.jpg',
        price: '24000',
        duration: '3 month',
        discreption: 'Computer numerical control (CNC) is a method for automating control of machine tools through the use of software embedded in a microcomputer attached to the tool. It is commonly used in manufacturing for machining metal and plastic parts.',
        features: {
            future: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            certificate: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            courseDetails: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.',
            skils: 'Notus JS Comes With A Huge Number Of Fully Coded CSS Components.'
        }, 
        teacher: 'Lutfar rahman',
        totalStudens: 400,
        rating: 2,
        totalAssignmet: 8,
        schedule: {
            day: ['Monday', 'Friday'],
            time: '2 houre',
            week: '2 days',
            time: '12.00 PM to 2.00 AM'
        },
        totalClasses: 16,

    },
]